export const ApiResponseStatus = {
  SUCCESS: "success",
  ERROR: "error"
};

export const CrewTypes = {
  LANDSCAPE: "landscape",
  MASONRY: "masonry",
  LIGHTING: "lighting",
  SUBCONTRACTOR: "subcontractor"
};

export const ProjectStatuses = {
  DESIGN: "design",
  ACTIVE: "active",
  WARRANTY: "warranty",
  INACTIVE: "inactive"
};

export const PhoneNumberTypes = {
  MOBILE: "mobile",
  HOME: "home",
  OFFICE: "office",
  OTHER: "other"
};

export const CompletionStatuses = {
  NOT_STARTED: "not-started",
  IN_PROGRESS: "in-progress",
  COMPLETED: "completed"
};

export const CompletionStatusLabels = {
  [CompletionStatuses.NOT_STARTED]: "Not Started",
  [CompletionStatuses.IN_PROGRESS]: "In Progress",
  [CompletionStatuses.COMPLETED]: "Completed"
};

export const ScopeItemTaskPriorities = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high"
};

export const CalendarTypes = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month"
};

export const TableRowGroupTypes = {
  DATETIME: "datetime"
};

export const DatetimeGroupByOptions = {
  DAY: "day",
  HOUR: "hour"
};

export const SettingTypes = {
  USER: "user-account",
  SCOPE: "scope-items"
};
